import React from 'react'

import ProductTable from './product-table'
import HTMLTable from './product-table-html'

import sw from '@uswitch/ev-utils/switch'
import { useEntity } from '@uswitch/ev-utils/context/selectors'
import { isEmpty } from '@uswitch/ev-utils/obj'

const VariantTable = ({ variant = 'rich', schema, ...props }) => {
  return sw({
    html: () => <HTMLTable {...props} />,
    card: () => <ProductTable {...props} card={true} {...schema} />,
    default: () => <ProductTable {...props} {...schema} />,
  })(variant.toLowerCase(), props)
}

const PT = ({ schema, dataset, filteredDataset, rowCount, ...props }) => {
  const datasetEntity = useEntity(dataset)
  const schemaEntity = useEntity(schema)
  const data = filteredDataset || datasetEntity.data

  const query = datasetEntity?.query

  const isElastic = !isEmpty(query)
  const invalidData = !schemaEntity.schema || !datasetEntity.data

  // TODO: report errors to Sentry
  if (isElastic) return null
  if (invalidData) return null

  return <VariantTable {...props} schema={schemaEntity.schema} data={data} />
}

export default PT
